import React from 'react'
import styles from './ScrollTop.module.scss'
import { ArrowUpOutlined } from '@ant-design/icons'
import { BackTop, Button } from 'antd'

const ScrollTop: React.FC = () => (
  <BackTop className={styles['scroll-up']}>
    <Button
      type='primary'
      shape='circle'
      size='large'
      className='radius-100'
      icon={<ArrowUpOutlined />}
    />
  </BackTop>
)

export default ScrollTop
